import {gql} from '@apollo/client'

export const DASHBOARD_NOTIFICATIONS = gql`
  query dashboardNotifications($per: Int!) {
    notifications(per: $per) {
      totalCount
      unreadCount
      list {
        id
        notificationContent {
          id
          type
          title
          link
          targetBlank
          reportName
          procedureStatusId
          employeeDependentId
          createdAt
        }
      }
    }
  }
`

export interface DashboardNotificationsQueryVariables {
  per: number
}

export interface DashboardNotificationsQueryResult {
  notifications: {
    totalCount: number
    unreadCount: number
    list: Notification[]
  }
}

export interface Notification {
  id: string
  notificationContent: NotificationContent
}

export interface NotificationContent {
  id: string
  type: string
  title: string
  link: string | null
  targetBlank: boolean | null
  reportName: string | null
  procedureStatusId: string | null
  employeeDependentId: string | null
  createdAt: string
}

export interface FileUploadNotification extends NotificationContent {
  type: 'FileUploadNotification'
  reportName: string
  procedureStatusId: string
}
